import { styled } from 'styled-components'
import { Batch } from '../../libs/batch-service'
import { Student } from '../../libs/student-service'
import { SingleButtonModal } from '../shared/Modal'
import { useState } from 'react'

interface Props {
    handleCancel: () => void
}

export default function OutcomeModal({ handleCancel }: Props) {
    return (
        <SingleButtonModal
            children={<OutcomeModalContent />}
            onCancel={handleCancel}
        />
    )
}

const Wrapper = styled.div`
    width: 250px;
    display: flex;
    flex-direction: column;
    align-items: left;
    background-color: #f7f8fa;
    padding: 20px;
    gap: 10px;
`

const Badge = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`

const HoveringText = styled.p`
    position: absolute;
    margin-top: -50px;
    color: white;
    background-color: grey;
    padding: 10px;
    border-radius: 8px;
`
const Img = styled.img`
    height: 20px;
`
const AchievingLabel = styled.p`
    color: #00b88c;
    font-size: 12px;
`
const ProgressingLabel = styled.p`
    color: #f4bd50;
    font-size: 12px;
`

const DevelopingLabel = styled.p`
    color: #ed6a5e;
    font-size: 12px;
`
const BadgeWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 20px;
`

function OutcomeModalContent() {
    const [achievingHidden, setAchievingHidden] = useState(true)
    const [progressingHidden, setProgressingHidden] = useState(true)
    const [developingHidden, setDevelopingHidden] = useState(true)
    return (
        <Wrapper>
            <p>What are the outcome levels?</p>
            <BadgeWrapper>
                <Badge
                    onMouseEnter={() => setAchievingHidden(false)}
                    onMouseLeave={() => setAchievingHidden(true)}
                >
                    {achievingHidden === false && (
                        <HoveringText>Achieving: All criteria met</HoveringText>
                    )}
                    <Img src="/images/report/achieving.png" />
                    <AchievingLabel>Achieving</AchievingLabel>
                </Badge>
                <Badge
                    onMouseEnter={() => setProgressingHidden(false)}
                    onMouseLeave={() => setProgressingHidden(true)}
                >
                    {progressingHidden === false && (
                        <HoveringText>
                            Progressing: All but one criterion met
                        </HoveringText>
                    )}
                    <Img src="/images/report/progressing.png" />
                    <ProgressingLabel>Progressing</ProgressingLabel>
                </Badge>
                <Badge
                    onMouseEnter={() => setDevelopingHidden(false)}
                    onMouseLeave={() => setDevelopingHidden(true)}
                >
                    {developingHidden === false && (
                        <HoveringText>
                            Developing: Two or more criteria not met
                        </HoveringText>
                    )}
                    <Img src="/images/report/developing.png" />
                    <DevelopingLabel>Developing</DevelopingLabel>
                </Badge>
            </BadgeWrapper>
            <div>
                Each skill score will be converted to a descriptive outcome
                based on the number of criteria achieved. Summary scores are
                provided for locomotor skills (skip, hop, jump, side step),
                object control skills (catch, kick, throw) and total skills per
                student.
            </div>
        </Wrapper>
    )
}
